import PropTypes from 'prop-types';

import Text from '@/atoms/Text/Text';
import RichText from '@/molecules/RichText/RichText';

import { TEXT_BASE_CLASS } from '@/atoms/Text/Text.constants';

export default function Ingredient({ contents, title, hideHeader = false, entries, num, length }) {
  return (
    <div className="aaco__ingredient flex flex-col gap-2">
      {title && !hideHeader && (
        <>
          <div>
            <Text tag="tag" style="dd-kr:hidden dd-en:hidden text-black mb-1 ">
              {num < 10 ? `0${num + 1}` : num + 1} / {length < 10 ? `0${length}` : length}
            </Text>
            <Text tag="h5" style="dd-kr:hidden dd-en:hidden text-acacia mb-4 ">
              {title}
            </Text>
            <hr className="border-black" />
          </div>
          <Text
            tag="h6"
            style="hidden dd-en:block dd-kr:block text-actual-dd-gold dd-en:mb-5 dd-kr:mb-5 mb-[24px] uppercase"
          >
            {title}
          </Text>
        </>
      )}
      {contents?.length > 0 &&
        contents.map(({ content, nodeType }, index) => {
          return (
            <RichText
              entries={entries}
              content={content}
              key={index}
              nodeType={nodeType}
              richTextStyle={{
                paragraph: {
                  customFont:
                    TEXT_BASE_CLASS['body'] +
                    ' text-black dd-en:text-white dd-kr:text-white',
                  paragraphWrapper: 'leading-5',
                },
                list: {
                  paragraph: {
                    customFont:
                      TEXT_BASE_CLASS['body'] +
                      ' text-black dd-en:text-white dd-kr:text-white',
                    paragraphWrapper: 'leading-5',
                    customLink:
                      TEXT_BASE_CLASS['body'] +
                      ' text-black underline underline-offset-[5px] decoration-[1.5px] decoration-eucalyptus',
                  },
                  ul: 'marker:font-heading marker:text-h5 marker:text-black marker:dd-kr:marker:text-white marker:dd-en:marker:text-white dd-kr:text-white dd-en:text-white pl-5',
                },
              }}
            />
          );
        })}
    </div>
  );
}

Ingredient.propTypes = {
  contents: PropTypes.array,
  hideHeader: PropTypes.bool,
  title: PropTypes.string,
};
